import { useCallback, useEffect, useState } from 'react';
import { DELIVERY_METHODS } from 'accounts/constants/home-keys';
import { HOME_KEYS_STRINGS } from 'accounts/constants/strings/home-keys.strings';
import { useSetupFlowStep } from 'accounts/hooks/homeowners/use-setup-flow-step-context';
// TODO: Regions: Fix it.
import { REGION_TYPES } from 'consts/address';
import { KeysDeliveredBy, PropertyType } from 'models/enums';

export function useHomeKeys({
  currentStep,
  isAdoptedResident,
}: {
  currentStep: any;
  isAdoptedResident: boolean;
}) {
  const { properties, fetchProperties } = useSetupFlowStep();
  // `init` below rebuilds these from `DELIVERY_METHODS`, swapping in region- and
  // flow-specific labels, so the stored entries are that shape with a label that
  // may be either copy or markup.
  const [deliveryMethods, setDeliveryMethods] = useState<
    (typeof DELIVERY_METHODS)[number][]
  >([]);
  const isSingleFamilyTypeProperty =
    currentStep?.property?.basicInfo?.propertyType ===
    PropertyType.SingleFamily;
  const isUnitInspectionCompleted =
    !!currentStep?.unit?.basicInfo?.isInspectionCompleted;
  const region = currentStep?.property?.coverageRegion?.region;
  const hasHoa = currentStep?.property?.basicInfo.hasHoa;

  const init = useCallback(() => {
    if (properties) {
      let isHomeownerAttendingInspection = false;

      for (const property of properties) {
        const unit = property.units.find(
          (currentUnit: any) =>
            currentUnit.basicInfo.unitId ===
            currentStep?.unit?.basicInfo?.unitId,
        );

        if (unit) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy lint baseline; see docs/development/lint-baseline-followups.md. Refs: ARCH-56
          isHomeownerAttendingInspection =
            unit.unitAdditional?.inspectionPreferences?.presencePreference;
        }
      }

      // TODO: Regions: Check it
      const newDeliveryMethod = DELIVERY_METHODS.filter((method) => {
        if (
          region === REGION_TYPES.MIAMI.name &&
          method.key === KeysDeliveredBy.DropOff
        ) {
          return false;
        }

        return true;
      }).map((method) => {
        if (method.key === KeysDeliveredBy.Lockbox) {
          return {
            ...method,
            label: HOME_KEYS_STRINGS['delivery.homeownerLockbox'],
          };
        }

        return method;
      });

      setDeliveryMethods(newDeliveryMethod);
    }
  }, [currentStep, isAdoptedResident, properties, region]);

  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    deliveryMethods,
    region,
    hasHoa,
    isSingleFamilyTypeProperty,
    isUnitInspectionCompleted,
  };
}
